import React, { useCallback, useEffect, useReducer, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import LookProject from "../../components/LookProject/LookProject";
import Interaction from "../../components/WriteProject/Interaction/Interaction";
import UsePostProject from "../../hooks/UsePostProject";
import { MeetupReducer } from "../../interface/ActionReducer";
import { MeetupState } from "../../interface/initialState";
import { MeetupDataChange } from "../../lib/lib";
import { RootState } from "../../reducers";
import { LeaderInter } from "../../reducers/data";
import "./css/index.css";

type LocationType = {
  state:
    | {
        prjt_id: string;
        prjt_sts_cd: string;
      }
    | undefined;
  pathname: string;
};

function WriteMeetup() {
  const location = useLocation() as LocationType;
  const path = location.pathname.split("/")[4];
  const leaderInfo = useSelector<RootState, LeaderInter>(
    (state) => state.data.leader
  );
  const [state, dispatch] = useReducer(MeetupReducer, undefined, MeetupState);

  const [PostProject, UpdateCommon, ProjectSave] = UsePostProject({
    type: "mtup",
    id: location.state?.prjt_id,
    prjtType: location.state?.prjt_sts_cd,
    dispatch,
    leaderInfo,
  });
  const [isError, setisError] = useState<boolean>(false);
  const [isLook, setIsLook] = useState<boolean>(false);
  const Valid = useCallback(() => {
    const step = Number(path);
    const {
      title,
      mainimg,
      category,
      max,
      finish_time,
      address: { basic },
      period: { start, finish },
      leader: { id },
    } = state;

    const startTime = new Date(start).getTime();
    const finishTime = new Date(finish).getTime();
    if (step === 1) {
      return (
        title &&
        mainimg &&
        finish_time &&
        (category || (max > 0 && basic)) &&
        finishTime > startTime &&
        id
      );
    } else {
      return true;
    }
  }, [state, path]);

  const InsertMeetup = useCallback(
    (template: string) => {
      PostProject(MeetupDataChange(state, template));
    },
    [PostProject, state]
  );

  const SaveMeetup = useCallback(
    (template: string | undefined) => {
      ProjectSave(MeetupDataChange(state, template ? template : ""));
    },
    [ProjectSave, state]
  );
  useEffect(() => {
    sessionStorage.setItem("write", JSON.stringify(state));
    return () => {};
  }, [state]);

  return (
    <main className="write-project" id="wirte-project">
      <div
        className="wrapper"
        style={
          path === "4"
            ? {
                paddingTop: "165px",
              }
            : undefined
        }
      >
        <div className="write-header">
          <div className="left">
            <div className="title">신규 밋업 업로드</div>
            <div className="step-wrapper">
              {nav_layouts.map(({ title, path }, idx) => {
                return (
                  <div
                    className={path === location.pathname ? "nav-active" : ""}
                    key={idx}
                  >
                    0{idx + 1} {title}
                  </div>
                );
              })}
            </div>
          </div>
          {path !== "4" ? (
            <button
              onClick={() => {
                setIsLook(true);
              }}
            >
              미리보기
            </button>
          ) : undefined}
        </div>
        <Outlet
          context={{
            state,
            dispatch,
            isError,
            UpdateCommon,
            Insert: InsertMeetup,
            Save: SaveMeetup,
            setIsLook,
            status:
              location.state && location.state.prjt_sts_cd ? "fix" : "new",
            type: "meetup",
          }}
        />
        {Number(path) < 4 ? (
          <Interaction
            path={Number(path)}
            type={location.state ? "fix" : "new"}
            setisError={setisError}
            valid={Valid}
            Save={SaveMeetup}
            data={location.state}
          />
        ) : undefined}
      </div>
      <LookProject
        Data={state}
        type="meetup"
        categoryContent={state.category === "OFFLINE" ? "대면" : "비대면"}
        price={state.price}
        isLook={isLook}
        Cancel={setIsLook}
      />
    </main>
  );
}

export default WriteMeetup;

const nav_layouts = [
  {
    title: "기본정보",
    path: "/mtup/write/step/1",
  },
  {
    title: "팀플리더 소개",
    path: "/mtup/write/step/2",
  },
  {
    title: "패널티 및 강퇴조건",
    path: "/mtup/write/step/3",
  },
  {
    title: "상세내용",
    path: "/mtup/write/step/4",
  },
];
